var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import * as React from "react";
import { Icon } from "@/components/ui/Icon";
import { cn } from "@/lib/utils";
const buttonVariants = cva("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md f-14-500-16 ring-offset-background transition-colors focus:outline-none focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:w-4 [&_svg]:h-4", {
    variants: {
        size: {
            md: "h-[32px] px-4",
            lg: "h-[48px] px-6",
        },
        variant: {
            "button-base-alt": "bg-button-base-alt hover:bg-button-base-alt-hover",
            "base-alt": "bg-button-base-alt hover:bg-button-base-alt-hover text-text-primary [&_svg]:fill-current [&_svg_*]:fill-current",
            base: "text-text-primary [&_svg]:fill-current [&_svg_*]:fill-current bg-button-base border border-border-base hover:border-border-base-hover  hover:[&_svg]:fill-current hover:[&_svg_*]:fill-current active:border-border-base-active  active:[&_svg]:fill-current active:[&_svg_*]:fill-current disabled:text-text-tertiary disabled:[&_svg]:fill-current disabled:[&_svg_*]:fill-current",
            "base-no-border": "text-text-primary [&_svg]:fill-current [&_svg_*]:fill-current bg-transparent border-0 hover:bg-background-base-hover active:bg-background-base-hover disabled:text-text-tertiary disabled:[&_svg]:fill-current disabled:[&_svg_*]:fill-current",
            accent: "text-text-primary [&_svg]:fill-current [&_svg_*]:fill-current bg-button-accent-1 hover:bg-button-accent-1-hover hover:text-text-contrast hover:[&_svg]:fill-current hover:[&_svg_*]:fill-current active:bg-button-accent-1-active active:text-text-contrast active:[&_svg]:fill-current active:[&_svg_*]:fill-current disabled:bg-button-accent-1-disabled disabled:text-text-tertiary disabled:[&_svg]:fill-current disabled:[&_svg_*]:fill-current",
            destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
            outline: "border border-border-base bg-background-base text-text-primary hover:bg-background-base-hover hover:border-border-base-hover focus:border-border-base-active disabled:border-border-base-disabled disabled:bg-background-base-disabled disabled:text-text-tertiary",
            secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
            ghost: "text-slate-700 hover:bg-slate-100 hover:text-slate-900",
            errorText: "bg-transparent border-0 text-text-error hover:bg-background-accient-2-pale-hover disabled:text-text-error-disabled disabled:[&_svg]:fill-current disabled:[&_svg_*]:fill-current hover:text-text-error",
            link: "text-primary underline-offset-4 hover:underline",
        },
        shape: {
            default: "",
            rounded: "h-[30px] px-3 rounded-[68px] gap-2",
        },
    },
    defaultVariants: {
        size: "md",
        variant: "button-base-alt",
        shape: "default",
    },
});
const Button = React.forwardRef((_a, ref) => {
    var { className, variant, size, shape, asChild = false, icon, iconFill, children } = _a, props = __rest(_a, ["className", "variant", "size", "shape", "asChild", "icon", "iconFill", "children"]);
    const Comp = asChild ? Slot : "button";
    return (_jsx(Comp, Object.assign({ className: cn(buttonVariants({ variant, size, shape }), className), ref: ref }, props, { children: asChild ? (children) : (_jsxs(_Fragment, { children: [icon ? _jsx(Icon, { name: icon, fill: iconFill }) : null, children] })) })));
});
Button.displayName = "Button";
export { Button, buttonVariants };
